import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faYoutube,
  faInstagram,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import OptimizedImage from "hooks/OptimizedImage";
import copyIcon from "assets/copy_icon.svg";
import toast from "react-hot-toast";

export default function FooterContact() {
  const handleCopy = (id) => {
    const textToCopy = document.getElementById(id);
    if (textToCopy) {
      navigator.clipboard
        .writeText(textToCopy.textContent)
        .then(() => {
          toast.success("Copied");
        })
        .catch((err) => {
          toast.error("Failed to copy text:", err);
        });
    }
  };

  return (
    <footer>
      <div className="pb-10 bg-basecol text-gray px-10 md:pl-10 xl:px-0 lg:mb-[-100px] lg:pt-3">
        <div className=" lg:max-w-7xl max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-2 justify-items-start md:p-0 sm:p-7 md:pb-10 md:gap-y-14 xl:gap-y-0 items-center lg:mb-20 xl:flex lg:items-start xl:gap-10">
            <div className="hidden lg:flex gap-4 lg:mr-10 ">
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/certificates/ISO_9001.webp"
                alt="ISO9001"
                className="w-24 lg:w-[100px] h-auto"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/certificates/ISO_17100.webp"
                alt="ISO17100"
                className="w-24 lg:w-[100px] h-auto"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/certificates/ISO_18587.webp"
                alt="ISO18587"
                className="w-24 lg:w-[100px] h-auto"
              />
            </div>
            <div className="font-opensans mb-10 lg:mb-0 md:mb-0">
              <div className="flex items-start">
                <OptimizedImage
                  src="https://tomedes.gumlet.io/assets/images/footer-images/address.svg"
                  alt="address"
                  className="mr-5 w-4"
                />
                <div>
                  <p className="text-sm font-opensans font-normal text-[#C5C5C5] mb-[6px]">
                    Tomedes Ltd - USA 9450 SW{" "}
                  </p>
                  <p className="text-sm font-opensans font-normal text-[#C5C5C5] leading-7">
                    Gemini Dr #34540,{" "}
                    <span className="lg:block"> Beaverton, Oregon</span>{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-start mb-10 md:mb-0  xl:ml-[2.5rem] ">
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/images/footer-images/call.svg"
                alt="contact"
                className="mr-5 w-4"
              />
              <div className="">
                <a
                  href="tel:+19852390142"
                  className="text-sm font-opensans font-normal text-[#C5C5C5] mb-[6px]"
                >
                  US: +1 985 239 0142
                </a>

                <p className="text-sm font-opensans font-normal text-[#C5C5C5]">
                  <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
                </p>
              </div>
            </div>
            <div className=" md:mr-6 flex flex-col gap-10 md:gap-5 xl:ml-[2.25rem]">
              <div className="flex gap-1 items-center">
                <OptimizedImage
                  src="https://tomedes.gumlet.io/assets/images/footer-images/mail.svg"
                  alt="email"
                  className="mr-5 w-4"
                />
                <p className="text-sm font-opensans font-normal text-[#C5C5C5]">
                  <a href="mailto:support@tomedes.com" id="footer_email">
                    support@tomedes.com
                  </a>
                </p>
                <img
                  src={copyIcon}
                  className="ml-2 cursor-pointer"
                  onClick={() => handleCopy("footer_email")}
                />
              </div>
              <div className="flex items-center md:justify-start xl:col-span-full xl:justify-self-end">
                <div className="w-9/12 flex items-center justify-between">
                  <a
                    className="p-2 social_media_icon_parent group"
                    href="https://www.facebook.com/Tomedes.translation/"
                    target="_blank"
                  >
                    <FontAwesomeIcon
                      className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white"
                      icon={faFacebookF}
                    />
                  </a>
                  <a
                    href="https://twitter.com/Tomedes"
                    target="_blank"
                    className=" social_media_icon_parent group"
                  >
                    <svg
                      className="social_media_icon_hover"
                      fill=""
                      width="40"
                      zoomAndPan="magnify"
                      viewBox="0 0 375 374.999991"
                      height="40"
                    >
                      <defs>
                        &lt; d="M 8.917969 7.773438 L 367.417969 7.773438 L
                        367.417969 366.273438 L 8.917969 366.273438 Z M 8.917969
                        7.773438 " /&gt;{" "}
                      </defs>

                      <g transform="translate(90,80) ">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 44 44"
                          version="1.1"
                          height="full"
                          width="full"
                        >
                          <path
                            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </g>
                    </svg>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/tomedes.com"
                    target="_blank"
                    className="p-2 social_media_icon_parent group"
                  >
                    <FontAwesomeIcon
                      className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white"
                      icon={faLinkedinIn}
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw"
                    target="_blank"
                    className="p-2 social_media_icon_parent group"
                  >
                    <FontAwesomeIcon
                      className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white"
                      icon={faYoutube}
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/tomedes_translation/"
                    target="_blank"
                    className="p-2 social_media_icon_parent group"
                  >
                    <FontAwesomeIcon
                      className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white"
                      icon={faInstagram}
                    />
                  </a>
                  <a
                    href="https://www.tiktok.com/@tomedestranslation"
                    target="_blank"
                    className="p-2 social_media_icon_parent group"
                  >
                    <FontAwesomeIcon
                      className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white"
                      icon={faTiktok}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
